import React from 'react';
import { Alert } from 'react-bootstrap';

import { showCookiePolicyBanner } from '../../../store/actions/session';
import { isCookiePolicyBannerHidden, hideCookiePolicyBanner } from '../../../storage/localStorage';

import './cookiePolicyBanner.scss';

class CookieBanner extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleDismiss = this.handleDismiss.bind(this);

        this.state = {
            show: !isCookiePolicyBannerHidden(),
        }
    };

    handleDismiss() {
        hideCookiePolicyBanner();
        showCookiePolicyBanner(false);
        this.setState({ show: false });
    };

    render() {
        return <div>
            {this.state.show && <Alert bsClass="cookie" onDismiss={this.handleDismiss}>
                <p>
                    This website uses cookies to enhance and improve your browsing experience.
                    For further information on how we use cookies and how to change your browser settings,
                    please read our <a href="https://www.halo.fitness/web/developerTos.jsp?locale=en&selectedTncTab=cookie"
                        target="_blank"
                        rel="noopener noreferrer">
                        Cookie Policy
                    </a>.
                </p>
            </Alert>}
        </div>
    };
};

export default CookieBanner;



// WEBPACK FOOTER //
// ./src/components/core/CookiePolicyBannerComponent/CookiePolicyBannerComponent.js